import { Box, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import GenericButton from "components/Buttons/GenericButton";
import { useFormContext } from "react-hook-form";
import CancelButton from "./cancel-button";

export default function NavigationButtons({ nextLabel = "Seguinte", handleBack, canGoBack, showCancel = false }) {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <Box
      gridGap={12}
      display="flex"
      flexDirection={isSmDown ? "column" : "row"}
      alignItems={isSmDown ? "stretch" : "center"}
      justifyContent={isSmDown ? "stretch" : "flex-end"}
      marginBottom={4}
    >
      {showCancel && <CancelButton fullWidth={isSmDown} size={isSmDown ? "medium" : undefined} />}
      <GenericButton
        id="back-button"
        disabled={!canGoBack || isSubmitting}
        onClick={handleBack}
        color="tertiary"
        fullWidth={isSmDown}
        size={isSmDown ? "medium" : undefined}
      >
        Voltar
      </GenericButton>
      <GenericButton
        loading={isSubmitting}
        id="next-button"
        typeSubmit
        color="primary"
        fullWidth={isSmDown}
        size={isSmDown ? "medium" : undefined}
      >
        {nextLabel}
      </GenericButton>
    </Box>
  );
}
